import { logDataDogEvent } from 'utils/datadog';

/**
 * Correlates a Zoom-side support ticket with our own logs. Generated BEFORE the request and
 * logged on every outcome, because a trace id Zoom quotes back is only useful if the same
 * value exists on our side to search for. Returning one we never recorded would be worse than
 * sending none: it looks like correlation and is not.
 */
export const createTraceId = () =>
  `lifemd-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;

/**
 * Every failure path is logged, with the trace id so a Zoom ticket resolves to a record here.
 * Identity failing silently is the dangerous outcome: chat keeps working, agents quietly stop
 * seeing verified patients, and nobody notices. The reason and the trace id are recorded,
 * never the token or any claim.
 *
 * Shared by the credential hook and the watchdog rather than duplicated, so a search for this
 * feature returns both what was requested and what was never requested at all — the second being
 * invisible by nature, and the reason the watchdog exists.
 */
export const reportIdentityOutcome = ({
  level,
  reason,
  traceId
}: {
  level: 'info' | 'warn';
  reason: string;
  traceId: string;
}) =>
  logDataDogEvent({
    context: { feature: 'zoom-chat-consumer-auth', reason, traceId },
    level,
    message: 'Zoom chat consumer identity outcome'
  });
